import React from 'react';
import { useEffect, useState } from 'react';
import * as styles from 'src/uglib_styles/serviceDisruptionBar.module.css'

function ServiceDisruptionBar (props) {

	let [incidents, setIncidents] = useState([]);
	let [maintenances, setMaintenances] = useState([]);

	function filter_maintenance(event) {
		// Show maintenances that are in progress
		if(event.status === "INPROGRESS") {
			return true;
		}

		// Don't show completed maintenance
		if (event.status === "COMPLETED") {
			return false;
		}

		/**
		 * INPROGRESS status
		 * 
		 * Only show items that are happening within 5 days.
		 */
		 
		const today = new Date();
		const cutoff_date = new Date();
		cutoff_date.setDate(today.getDate() + 5); 

		const maintenance_date = new Date(event.start);

		return (maintenance_date <= cutoff_date);
	}
	
	useEffect(() => {

		const fetch_data = function() {
			const baseUrl = 'https://app.lib.uoguelph.ca/api/get-instatus-json/';

			fetch(baseUrl)
			.then((response) => response.json())
			.then((response) => {
				if ('activeIncidents' in response) {
					setIncidents(response.activeIncidents)
				}
				return response;
			})
			.then((response) => {
				if ('activeMaintenances' in response) {
					const upcoming_maintenance = response.activeMaintenances.filter(filter_maintenance);
					setMaintenances(upcoming_maintenance)
				}
			});
		}

		fetch_data();
		setInterval(fetch_data, 30000)
	}, []);

	let incidents_list = incidents.map((i) => {
		let btn_classes =  " btn btn-outline-info";

		if (i.impact === "MAJOROUTAGE") {
			btn_classes = " btn btn-outline-danger"
		}

		return (
			<li className={styles.incident}>
				<a className={styles.button + btn_classes} href={ i.url }>
					<span className="icon fa fa-bolt-slash"></span>
					<span>{ i.name }</span>
				</a>
			</li>
		)
	});

	let maintenances_list = maintenances.map((i) => {
		return (
			<li className={styles.maintenance}>
				<a className={styles.button + " btn btn-outline-info"} href={ i.url }>
					<span className="icon fa fa-gear"></span>
					<span>{ i.name }</span>
				</a>
			</li>
		)
	});

	if(incidents_list.length === 0 && maintenances_list.length === 0) {
		return <></>;
	}

	return (<>
		<div className={styles.service_disruptions}>
			<div className={styles.icon_wrap} aria-hidden="true"><span className={styles.icon + " fa fa-circle-exclamation"}></span><span>Notice</span></div>
			<ul>
				{incidents_list}
				{maintenances_list}
			</ul>
			
		</div>
		
	</>);
	
}

export default ServiceDisruptionBar